import { render, staticRenderFns } from "./t-dialog-form.vue?vue&type=template&id=2a88ca52&"
import script from "./t-dialog-form.vue?vue&type=script&lang=js&"
export * from "./t-dialog-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports